import { ReimbursementRequestBodyDto } from '@mca-feature';
import { BaseMapper } from '@shared/data';
import { ReimbursementRequestBodyModel } from '../../../../../core/interface/claims/reimbursement-body-model';

export class ReimbursementRequestMapper extends BaseMapper<ReimbursementRequestBodyModel, ReimbursementRequestBodyDto> {
    public mapDtoToModel(dto: ReimbursementRequestBodyDto): ReimbursementRequestBodyModel {
        return {
            customerId: dto.customerId,
            insurancePolicyNumber: dto.insurancePolicyNumber,
            accidentDate: this.stringDateToDayjs(dto.accidentDate),
            submittedAs: dto.submittedAs,
            bankAccountNumber: dto.bankAccountNumber,
            bankName: dto.bankName,
            maskedDocumentIds: dto.maskedDocumentIds,
        };
    }

    override mapModelToDto(model: ReimbursementRequestBodyModel): ReimbursementRequestBodyDto {
        return {
            customerId: model.customerId,
            insurancePolicyNumber: model.insurancePolicyNumber,
            accidentDate: this.dayjsFormatForDto(model.accidentDate),
            submittedAs: model.submittedAs,
            bankAccountNumber: model.bankAccountNumber,
            bankName: model.bankName,
            maskedDocumentIds: model.maskedDocumentIds,
        };
    }
}
